export default "__VITE_ASSET__1f3162dd__"